import { useQuery } from '@tanstack/react-query';

import { agent } from 'api/agent';
import { CropProps } from 'utils/types';

export const fileKey = ['fileCrop'];

const useCroptimizerCrop = () => useQuery({
  queryKey: [fileKey, 'croptimizer'],
  queryFn: () => agent.getClient()('file-data/croptimizer?tag=crops').then((response) => {
    const result: CropProps[] = [];
    response?.data?.data?.forEach((element: any) => {
      result.push({
        ['Country']: element?.['0'],
        ['Crops']: element?.['1'],
        ['PotentialYeild']: element?.['2'],
        ['Price']: element?.['3'],
        ['YeildLossesCurrentTargetPH']: element?.['4'],
        ['YeildLossesCurrentPH']: element?.['5'],
        ['YeildLossesTargetPH']: element?.['6'],
        ['EquationYeildLosses']: element?.['7'],
        ['GroupYeildLosses']: element?.['8'],
        ['GroupYeildOptimumPH']: element?.['9'],
        ['CropRotationReminder']: element?.['10'],
      });
    });

    return result as CropProps[];
  }),
  staleTime: 5 * 60 * 1000,
  gcTime: 10 * 60 * 1000,
});

export default useCroptimizerCrop;